import { gql } from "@apollo/client";

export const GET_SPECIFIC_CASE_BY_ID = gql`
  query GetSpecificCaseById($caseId: String!) {
    getCaseById(id: $caseId) {
      id
      caseNumber
      orgId
      status
      createdAt
      updatedAt
      referral {
        id
        from
        user {
          id
          firstName
          lastName
          country
          avatarUrl
          isDeleted
          email
          gender
          employmentStatus
          disability
          dob
          housingStatus
          incomeLevel
          insurance
          household
          createdAt
          updatedAt
          phone
          ext
          verified
        }
        userId
        eligibilityStatus
        serviceId
        serviceName
        orgId
        status
        isSelfReferral
      }
    }
  }
`;
